import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import { numMulti } from '@src/utils'
import BaseComponent from '@base/BaseComponent'
// import { isEmpty } from 'lodash'
import { IconCodeEmum, Iconfont } from '@src/components'
import { Modal } from 'antd-mobile'
// import IconRight from '@assets/icon/ic_right.png'
import './main.scss'
import CSS from './index.module.css'

class ServiceModal extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		orderDetail: PropTypes.object,
		close: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		title: '',
		orderDetail: {
			orderBase: {},
			priceDetail: {},
			orderDiscountList: [],
			orderRefundDetailsResDTO: {},
		},
		close: () => {},
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 生命周期 */
	constructor(props) {
		super(props)
		this.state = {
			activeIndex: -1,
		}
	}

	render() {
		let { isShow, close, title, orderDetail } = this.props
		const { orderBase, priceDetail, orderDiscountList, orderRefundDetailsResDTO } = orderDetail

		return (
			<Modal
				popup
				visible={isShow}
				animationType='slide-up'
				onClose={close.bind(this)}
				className={CSS.modalRefound}
			>
				<div className='scroll-view-comp'>
					<div className='modal-title'>
						<label>{title}</label>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{ fontSize: '.32rem', color: '#D8D8D8' }}
							onPress={close.bind(this)}
						/>
					</div>

					{orderBase.orderStatus !== 60 ? (
						<div className='tip-view'>
							<div className='tip-line'>
								<label className='tip-left_text'>保价服务</label>
								<label className='tip-right_text'>
									¥
									{numMulti(
										orderDetail.priceDetail.insurancePrice || 0,
										orderDetail.priceDetail.insuranceCount || 0,
									)}
								</label>
							</div>
							{priceDetail.priceModeList &&
								priceDetail.priceModeList.map((item, index) => (
									<div className='tip-line' key={index}>
										<label className='tip-left_text'>
											{item.priceModeName}
										</label>
										<label className='tip-right_text'>
											¥{numMulti(item.salePrice, item.saleCopies)}
										</label>
									</div>
								))}
							{orderDiscountList &&
								orderDiscountList.map((item, index) => (
									<div className='tip-line' key={index}>
										<label className='tip-left_text'>{item.discountName}</label>
										<label className='tip-right_text red-text'>
											-¥{item.discountMoney}
										</label>
									</div>
								))}
							<div
								className='tip-line price-line'
								style={{
									paddingTop: '20px',
								}}
							>
								<label className='tip-left_text'>合计</label>
								<label className='tip-right_text red-text'>
									¥{orderDetail.orderBase.paymentPrice || 0}
								</label>
							</div>
						</div>
					) : (
						<div className='tip-view'>
							{orderRefundDetailsResDTO.itemList &&
								orderRefundDetailsResDTO.itemList.map((item, index) => (
									<div className='tip-line' key={index}>
										<label className='tip-left_text'>{item.refundName}</label>
										<label className='tip-right_text'>
											¥{numMulti(item.refundAmount, item.quantity)}
										</label>
									</div>
								))}
							{orderDiscountList &&
								orderDiscountList.map((item, index) => (
									<div className='tip-line' key={index}>
										<label className='tip-left_text'>{item.discountName}</label>
										<label className='tip-right_text red-text'>
											-¥{item.discountMoney}
										</label>
									</div>
								))}
							<div
								className='tip-line price-line'
								style={{
									paddingTop: '20px',
								}}
							>
								<label className='tip-left_text'>退款金额</label>
								<label className='tip-right_text red-text'>
									¥{orderDetail.orderRefundDetailsResDTO.refundAmount || 0}
								</label>
							</div>
						</div>
					)}
				</div>
			</Modal>
		)
	}
}

export default ServiceModal
